import { render } from "./Insurance.vue?vue&type=template&id=36dcb548&scoped=true"
import script from "./Insurance.vue?vue&type=script&lang=js"
export * from "./Insurance.vue?vue&type=script&lang=js"

import "./Insurance.vue?vue&type=style&index=0&id=36dcb548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dcb548"]])

export default __exports__